import React, { useState } from "react";
import api from "views/auth/Api";
import { API_BASE_URL } from '../../../../configs/AppConfig';

 const McqQuiz= ({questions,trainingId}) => {
  // const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [result, setResult] = useState(null);
  const [current, setCurrent] = useState(0);

//   useEffect(() => {
//     api.get("${API_BASE_URL}mcq-projects").then(res => {
//     setQuestions(res.data);
//   });
// }, [data]);
console.log(trainingId,"assignProject")

  const handleNext = () => {
    if (current < questions.length - 1) {
      setCurrent(current + 1);
    } else {
      handleSubmit(); // last question → submit
    }
  };

  const handleSelect = (qId, option) => {
    setAnswers(prev => ({ ...prev, [qId]: option }));
  };

  const handleSubmit = async () => {
    const payload = {
      answers: Object.entries(answers).map(([questionId, answer]) => ({
        questionId: Number(questionId),
        answer,
      })),
      trainingId: trainingId,
    };

    const res = await api.post(`${API_BASE_URL}mcq-training`, payload);
    setResult(res.data);
    setSubmitted(true);
  };

  if (questions.length === 0) return <p>Loading...</p>;

  if (submitted && result) {
    return (
      <div className="max-w-2xl mx-auto mt-10 mb-10 p-6 bg-white shadow rounded-2xl">
        <h2 className="text-xl font-bold mb-3">🎯 Quiz Results</h2>
        <p>Total Score: {result.totalScore}</p>
        <p>
          Correct Answers: {result.correctCount}/{result.totalQuestions}
        </p>
        <hr className="my-3" />
        {result.answers.map(r => (
          <div key={r.questionId} className="mb-3">
            <p className="font-medium">{r.questionText}</p>
            <p
              className={
                r.isCorrect ? "text-green-600" : "text-red-600"
              }
            >
              Your Answer: {r.selected}
            </p>
            {!r.isCorrect && (
              <p className="text-gray-600">
                Correct: {r.correctAnswer}
              </p>
            )}
          </div>
        ))}
      </div>
    );
  }
  const q = questions[current];

  return (
    <div className="max-w-xl mx-auto mt-10 mb-10 p-6 bg-white shadow rounded-2xl">
      <h2 className="text-xl font-bold mb-4">
        Question {current + 1} of {questions.length}
      </h2>

      <p className="font-medium mb-3">{q.questionText}</p>
      <div className="space-y-2">
        {q.options.map((opt, i) => (
          <label
            key={i}
            className={`block border rounded p-2 cursor-pointer hover:bg-gray-100 ${
              answers[q.id] === opt ? "bg-blue-100 border-blue-400" : ""
            }`}
          >
            <input
              type="radio"
              name={`q-${q.id}`}
              value={opt}
              checked={answers[q.id] === opt}
              onChange={() => handleSelect(q.id, opt)}
              className="mr-2"
            />
            {opt}
          </label>
        ))}
      </div>

      <button
        onClick={handleNext}
        disabled={!answers[q.id]}
        className="bg-blue-600 text-white px-4 py-2 rounded mt-4 block ml-auto hover:bg-blue-700 disabled:opacity-50"
      >
        {current === questions.length - 1 ? "Submit" : "Next"}
      </button>
    </div>
  );
}
export default McqQuiz;
